import { authedFetch } from './backendFetch';

export const ATTACHMENT_OCR_ENABLED = process.env.REACT_APP_ATTACHMENT_OCR_ENABLED === 'true';
export const canReviewOcr = (item) => item?.type === 'Attachment' && Boolean(item.path) &&
  /\.(pdf|docx|jpe?g|png)$/i.test(item.path);

export async function attachmentOcrRequest(method, path, fields = {}, signal) {
  try {
    const base = (process.env.REACT_APP_MAIN_BACKEND_URL || '').replace(/\/$/, '');
    const url = `${base}/scribe/attachments/ocr${method === 'GET' ? `?${new URLSearchParams({ path })}` : ''}`;
    const response = await authedFetch(url, {
      method, signal, cache: 'no-store',
      ...(method !== 'GET' ? {
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...fields, path }),
      } : {}),
    });
    if (!response.ok) {
      // Never display a raw gateway/provider response to the user.
      const messages = {
        400: 'This file is too large or unsupported. Use DOCX, PDF (up to 50 pages), JPG or PNG.',
        403: 'You no longer have access to this file.',
        404: 'OCR is not available in this environment yet.',
        409: 'The file or saved text has changed. Copy your edits before reloading.',
        422: 'The file could not be fully read. For complex Word content, export to PDF. For scans, use a clearer image or unlocked PDF.',
        504: 'OCR took too long. Please try a shorter file.',
      };
      const error = new Error(messages[response.status] || 'OCR is temporarily unavailable. Please try again.');
      error.status = response.status;
      throw error;
    }
    const data = await response.json();
    if (!['not_started', 'processing', 'ready', 'failed'].includes(data?.status) ||
        (data.status === 'ready' && (!Array.isArray(data.pages) || !data.pages.length ||
          data.pages.some((page, index) => page.page !== index + 1 || typeof page.text !== 'string')))) {
      throw new Error('Invalid OCR response');
    }
    return data;
  } catch (error) {
    if (error.name === 'AbortError' || error.status) throw error;
    throw new Error('OCR text could not be loaded. Please try again in a moment.');
  }
}
